var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wrapper" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("ul", { staticClass: "status-menu" }, [
          _c(
            "li",
            {
              staticClass: "status-menu-item",
              class:
                _vm.tableType == _vm.consts.reportType.upcoming
                  ? "selected"
                  : null,
              on: {
                click: function($event) {
                  _vm.navigateTab(_vm.consts.reportType.upcoming)
                }
              }
            },
            [_vm._v("\n          upcoming\n        ")]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "status-menu-item",
              class:
                _vm.tableType == _vm.consts.reportType.completed
                  ? "selected"
                  : null,
              on: {
                click: function($event) {
                  _vm.navigateTab(_vm.consts.reportType.completed)
                }
              }
            },
            [_vm._v("\n          completed\n        ")]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row status-message" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _vm._v(
          "\n      " +
            _vm._s(_vm.consts.reportMessage[_vm.tableType]) +
            "\n    "
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {},
      [
        _c("SubHeaderManageReports", {
          attrs: {
            pagingObj: _vm.pagingObj,
            eventStatus: _vm.tableType,
            sliderValue: _vm.sliderValue,
            textSearch: _vm.textSearch
          },
          on: {
            TEXT_SEARCH_CHANGE: _vm.handleTextSearchChange,
            CHANGE_FILTER_OPTION: _vm.handleChangeDataFilter,
            SLIDER_CHANGE_VALUE: _vm.handleSliderChangeValue
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("router-view", {
          attrs: {
            reportType: _vm.tableType,
            dateOut: _vm.sliderValue,
            filterBy: _vm.dataFilter,
            textSearch: _vm.textSearch
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12 container-header" }, [
        _vm._v("reports\n      "),
        _c("div", { staticClass: "icon-information" })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-507efb36", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-507efb36","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eventManagement/main/Reports.vue
// module id = 2015
// module chunks = 1